/**
 * Datepicker
 *
 * @since 1.0.0
 */

import Pikaday from 'pikaday'

const Translations = {
  nl: {
    previousMonth: 'Vorige maand',
    nextMonth: 'Volgende maand',
    months: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']
  },
  de: {
    previousMonth: 'Letzten monat',
    nextMonth: 'Nächsten monat',
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ],
    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fre', 'Sa']
  }
}

const Datepicker = () => {
  const input = document.querySelector('.js-datepicker')
  if (!input) return

  const getFormattedDate = date => {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
  }

  const skip = input.dataset.skip
  const getSkippedDays = date => {
    if (skip == 'weekend') {
      return date.getDay() === 0 || date.getDay() === 6
    } else if (skip == 'none') {
      return false
    } else {
      return date.getDay() === parseInt(skip)
    }
  }
  const lang = document.querySelector('html').lang

  return new Pikaday({
    field: input,
    format: 'DD-MM-YYYY',
    i18n: Translations[lang],
    disableDayFn: date => {
      return getFormattedDate(date) === getFormattedDate(new Date()) || getSkippedDays(date)
    },
    minDate: new Date()
  })
}

export default Datepicker



// WEBPACK FOOTER //
// ./src/js/modules/DatePicker.js